import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Logout({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Logout</title>
      <path
        d="M15.75 16.5C15.75 16.0858 15.4142 15.75 15 15.75C14.5858 15.75 14.25 16.0858 14.25 16.5H15.75ZM14.25 8.0625C14.25 8.47671 14.5858 8.8125 15 8.8125C15.4142 8.8125 15.75 8.47671 15.75 8.0625H14.25ZM11 11.25C10.5858 11.25 10.25 11.5858 10.25 12C10.25 12.4142 10.5858 12.75 11 12.75V11.25ZM21 12L21.5303 12.5303C21.8232 12.2374 21.8232 11.7626 21.5303 11.4697L21 12ZM19.0303 8.96967C18.7374 8.67678 18.2626 8.67678 17.9697 8.96967C17.6768 9.26256 17.6768 9.73744 17.9697 10.0303L19.0303 8.96967ZM17.9697 13.9697C17.6768 14.2626 17.6768 14.7374 17.9697 15.0303C18.2626 15.3232 18.7374 15.3232 19.0303 15.0303L17.9697 13.9697ZM6 3.75H13V2.25H6V3.75ZM13 20.25H6V21.75H13V20.25ZM4.75 19V5H3.25V19H4.75ZM14.25 16.5V19H15.75V16.5H14.25ZM11 12.75H21V11.25H11V12.75ZM21.5303 11.4697L19.0303 8.96967L17.9697 10.0303L20.4697 12.5303L21.5303 11.4697ZM20.4697 11.4697L17.9697 13.9697L19.0303 15.0303L21.5303 12.5303L20.4697 11.4697ZM6 20.25C5.30964 20.25 4.75 19.6904 4.75 19H3.25C3.25 20.5188 4.48122 21.75 6 21.75V20.25ZM13 21.75C14.5188 21.75 15.75 20.5188 15.75 19H14.25C14.25 19.6904 13.6904 20.25 13 20.25V21.75ZM13 3.75C13.6904 3.75 14.25 4.30964 14.25 5H15.75C15.75 3.48122 14.5188 2.25 13 2.25V3.75ZM6 2.25C4.48122 2.25 3.25 3.48122 3.25 5H4.75C4.75 4.30964 5.30964 3.75 6 3.75V2.25ZM14.25 5V8.0625H15.75V5H14.25Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
